/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, address: NonNullable<unknown> }} Tracking_Mode_Segment_StopInputs */

const vi_tracking_mode_segment_stop = /** @type {(inputs: Tracking_Mode_Segment_StopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dừng ${i?.index} • ${i?.address}`)
};

/**

* @param {Tracking_Mode_Segment_StopInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_mode_segment_stop = /** @type {((inputs: Tracking_Mode_Segment_StopInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Mode_Segment_StopInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_mode_segment_stop(inputs)
});